import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEndpoints } from 'src/config/api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class GetAutoPaySequenceService {

  private apiUrl = ApiEndpoints.getAutoPaySequence;
  private setAutoPayUrl = ApiEndpoints.setAutoPay;
  private setPpiAutoPayUrl = ApiEndpoints.PPISetAutoPay;
  private setPpiAutoRedeemUrl = ApiEndpoints.dwSetAutoRedeem;

  constructor(private http:HttpClient) { }

  getAutoPaySequenceResponse(walletID: string, walletRole: string): Observable<any> {
    const url = `${this.apiUrl}`;
    let wallettoken=sessionStorage.getItem("walletheaders");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "bearer " + wallettoken
      }),
    };
    return this.http.post<any>(url, { walletID, walletRole },httpOptions);
  }

  setAutoPay(data: any): Observable<any> {
    let token=sessionStorage.getItem("headers");
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        "Authorization": "bearer " + token
      }),
    };
    const url = `${this.setAutoPayUrl}`;
    return this.http.post<any>(url, data, httpOptions);
  }


// For ParcelPro 

getAutoPaySequenceResponsePPI(request: { walletID: string, walletRole: string, sessionID: string }): Observable<any> {
    const url = `${this.apiUrl}`;
    let token = sessionStorage.getItem("walletheaders"); // Use the PPI token for auth

    if (!token) {
        console.error("Authorization Token not found for PPI sequence call.");
    }
    
    // NOTE: We assume the API endpoint for PPI is the same one as the existing `apiUrl` (dwgetautopaysequence)
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + token // Use Bearer for robustness
      }),
    };
    
    // Send the full request object containing walletID, walletRole, and sessionID
    return this.http.post<any>(url, request, httpOptions);
  }


  setPpiAutoPay(data: any): Observable<any> {
    let token = sessionStorage.getItem("walletheaders");

    if (!token) {
        console.error("Authorization Token not found in session storage.");
        // Depending on requirements, you might want to throw an error or redirect the user
    }
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + token
      }),
    };
    const url = `${this.setPpiAutoPayUrl}`;
    return this.http.post<any>(url, data, httpOptions);
  }

  setPpiAutoRedeem(data: any): Observable<any> {
    let token = sessionStorage.getItem("walletheaders");

    if (!token) {
        console.error("Authorization Token not found in session storage.");
        // Depending on requirements, you might want to throw an error or redirect the user
    }
    let httpOptions = {
      headers: new HttpHeaders({
        "Access-Control-Allow-Methods": "POST, GET",
        'Content-Type': 'application/json',
        "Authorization": "Bearer " + token
      }),
    };
    const url = `${this.setPpiAutoRedeemUrl}`;
    return this.http.post<any>(url, data, httpOptions);
  }

}
